module.exports = __webpack_public_path__ + "media/application/images/svgs/unlock-54c301a8ed5534b37ed0a49d81a50e98.svg";